import * as React from 'react';

import { IconProps } from './types';

const EmptyBoxIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    width="200px"
    height="200px"
    viewBox="0 0 16 16"
    ref={forwardedRef}
    {...props}
  >
    <path d="m15.66 7-.91-2.68L8.62.85a1.28 1.28 0 0 0-1.24 0L1.25 4.32.34 7a1.24 1.24 0 0 0 .58 1.5l.33.18V11a1.25 1.25 0 0 0 .63 1l5.5 3.11a1.28 1.28 0 0 0 1.24 0l5.5-3.11a1.25 1.25 0 0 0 .63-1V8.68l.33-.18a1.24 1.24 0 0 0 .58-1.5zM10 9.87l-.48-1.28L14 6.13l.44 1.28zM8 1.94 13.46 5 8 8 2.54 5zM1.52 7.41 2 6.13l4.48 2.46L6 9.87zm1 1.95 4.25 2.32.62-1.84v3.87L2.5 11zM13.5 11l-4.88 2.71V9.84l.63 1.84 4.25-2.32z" />
  </svg>
));

EmptyBoxIcon.displayName = 'EmptyBoxIcon';
export default EmptyBoxIcon;
